import { useCallback, useMemo } from "react";
import { useAssets, useChains } from "src/components/FetchConfig";
import { findChainInfo } from "src/utils/helper";

export const useFilterOptions = () => {
  const { assetObj } = useAssets();
  const { selectChainByPieces } = useChains();

  const chainAssetMapping: Record<
    string,
    Record<string, string>
  > = useMemo(() => {
    const approveAllowanceAssets = Object.values(assetObj).filter(
      ({ status, merchant_asset_configs }) =>
        status == 1 && merchant_asset_configs?.[0]?.support_auto_sweep,
    );

    return approveAllowanceAssets.reduce(
      (
        acc: Record<string, Record<string, string>>,
        { chain_id: chainId, chain_type: chainType, asset_name },
      ) => {
        const chainInfo = findChainInfo(String(chainType), chainId);

        if (!chainInfo) {
          return acc;
        }

        const key = chainInfo.chain_code;

        return {
          ...acc,
          [key]: {
            ...acc[key],
            [asset_name]: asset_name,
          },
        };
      },
      {},
    );
  }, [assetObj]);

  const chainNamesSelectOptions: Record<string, string> = useMemo(() => {
    if (!Object.keys(chainAssetMapping).length) {
      return {};
    }

    return Object.keys(chainAssetMapping).reduce(
      (acc: Record<string, string>, chainName) => {
        const { name } = selectChainByPieces({
          chain_name: chainName,
        });

        if (!name) {
          return acc;
        }

        return {
          ...acc,
          [name]: chainName,
        };
      },
      {},
    );
  }, [chainAssetMapping, selectChainByPieces]);

  const getCurrencySelectOptions = useCallback(
    (chainName: string) => chainAssetMapping?.[chainName] || {},
    [chainAssetMapping],
  );

  return {
    chainNamesSelectOptions,
    getCurrencySelectOptions,
  };
};
